import React from "react";
import PropTypes from "prop-types";
import { Dropdown } from "antd";
import {
  fetchDeviceNamesRequest,
  fetchDeviceProfilesRequest,
  fetchDeviceTypesRequest,
  fetchLocationsRequest,
  updateUI,
} from "../../store/actions/asset";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import getSingleAsset from "./common/utils/getSingleAsset";
import DOMPurify from 'dompurify';

const AssetProfileDropdownSingle = (props) => {
  const { name, id } = props;
  const assetData = useSelector((state) => state?.asset?.data?.assetList || []);
  const dispatch = useDispatch();

  const handleDeleteProfile = (id) => {
    dispatch(updateUI({ selectedAsset: { id, name }, opType: "delete" }));
  };

  const handleEditProfile = (id) => {
    const formData = getSingleAsset(assetData, id);
    dispatch(
      updateUI({
        selectedAsset: { id, name, opType: "edit", opHeaderText: "Edit", deviceid: formData?.step2?.deviceId?.id },
        opType: "edit",
        formData,
      })
    );
    dispatch(fetchDeviceTypesRequest());
    dispatch(fetchDeviceNamesRequest());
    dispatch(fetchLocationsRequest());
    dispatch(fetchDeviceProfilesRequest(formData?.step2?.deviceType));
  };

  const handleCloneProfile = (id) => {
    const formData = getSingleAsset(assetData, id, true);

    dispatch(
      updateUI({
        selectedAsset: { id, name, opType: "clone", opHeaderText: "Add" },
        opType: "clone",
        formData,
      })
    );
    dispatch(fetchDeviceTypesRequest());
    dispatch(fetchDeviceNamesRequest());
    dispatch(fetchLocationsRequest());
    dispatch(fetchDeviceProfilesRequest(formData?.step2?.deviceType));
  };

  const items = [
    {
      label: <span className="font-face-vzw">Actions</span>,
      key: `${id}-1`,
    },
    {
      label: (
        <Link
          to={`/assets/${DOMPurify.sanitize(id)}`}
          className="ats-text-btn"
          style={{ whiteSpace: "nowrap", textDecoration: "none" }}
        >
          View asset
        </Link>
      ),
      key: `${id}-2`,
    },
    {
      label: (
        <button onClick={() => handleEditProfile(id)} className="ats-text-btn">
          Edit asset
        </button>
      ),
      key: `${id}-3`,
    },
    {
      label: (
        <button
          onClick={() => handleDeleteProfile(id)}
          className="ats-text-btn"
        >
          Delete asset
        </button>
      ),
      key: `${id}-4`,
    },
    {
      label: (
        <button onClick={() => handleCloneProfile(id)} className="ats-text-btn">
          Clone asset
        </button>
      ),
      key: `${id}-5`,
    },
  ];

  return (
    <Dropdown
      key={`dropdown-${id}`}
      menu={{
        items,
      }}
      trigger={["click"]}
      overlayClassName="shipment-dropdown-overlay"
    >
      <button className="btn btn-link text-secondary">
        <i className="bi-three-dots-vertical fs-6" />
      </button>
    </Dropdown>
  );
};

AssetProfileDropdownSingle.propTypes = {
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
};

export default AssetProfileDropdownSingle;
